import { OutlineButtonProps, PrimaryButtonProps } from "@/types/types";
import { ReactNode } from "react";
export const PrimaryButton = ({
  children,
  disabled,
  onClick,
  className,
  color,
  textColor,
}: PrimaryButtonProps) => {
  const handleClick = onClick ? onClick : () => {};
  const defaultColor = "#ffffff";
  const defaultBgColor = "#DA5700";
  return (
    <button
      type="submit"
      onClick={handleClick}
      disabled={disabled}
      style={{
        color: textColor ? textColor : defaultColor,
        backgroundColor: color ? color : defaultBgColor,
      }}
      className={`${className} text-white rounded-[8px]  font-semibold   px-4 py-3`}
    >
      {children}
    </button>
  );
};
export const Button = ({
  children,
  disabled,
  onClick,
  className,
  color,
  textColor,
}: PrimaryButtonProps) => {
  const handleClick = onClick ? onClick : () => {};
  const defaultColor = "#ffffff";
  const defaultBgColor = "#DA5700";
  return (
    <button
      type="submit"
      onClick={handleClick}
      disabled={disabled}
      style={{
        color: textColor ? textColor : defaultColor,
        backgroundColor: color ? color : defaultBgColor,
      }}
      className={`${className} text-white rounded-[8px]  font-semibold  `}
    >
      {children}
    </button>
  );
};

export const OutlineButton = ({
  children,
  disabled,
  onClick,
  className,
}: OutlineButtonProps) => {
  const handleClick = onClick ? onClick : () => {};

  return (
    <button
      type="submit"
      onClick={handleClick}
      disabled={disabled}
      className={`${className}  rounded-[8px]  font-semibold  border border-[#D0D5DD]    px-4 py-3`}
    >
      {children}
    </button>
  );
};

export type ButtonProps = {
  children: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  padding?: string;
  backgroundColor?: string;
  color?: string;
  borderRadius?: string;
  fontSize?: string;
  fontWeight?: string;
  hoverBackgroundColor?: string;
  hoverColor?: string;
  border?: string;
  className?: string;
  variant?: "default" | "outline" | "normal";
  type?: "submit" | "button" | "reset" | undefined;
};

export type IconButtonProps = {
  children: React.ReactNode;
  type?: "submit" | "button" | "reset";
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
  icon?: any;
};
export const IconButton = ({
  children,
  type = "button",
  disabled,
  onClick,
  className,
  icon,
}: IconButtonProps) => {
  const handleClick = onClick ? onClick : () => {};

  return (
    <button
      onClick={handleClick}
      disabled={disabled}
      className={`${className} 
      flex justify-center gap-3 border border-[#D8D8DE] py-[10px] px-4 rounded-[8px] text-caption-1-large font-medium
      `}
      type={type}
    >
      {icon}
      {children}
    </button>
  );
};

export const CustomButton = ({
  children,
  onClick,
  padding = "10px 20px",
  backgroundColor = "#FF7300",
  color = "#ffffff",
  borderRadius = "12px",
  fontSize = "16px",
  fontWeight = "500",
  hoverBackgroundColor,
  hoverColor,
  border,
  className = "",
  variant = "default",
}: ButtonProps) => {
  const handleClick = onClick ? onClick : () => {};
  // Define styles based on variant
  const variantStyles = {
    default: {
      backgroundColor,
      color,
      border: border || `2px solid ${backgroundColor}`,
      hoverBackgroundColor: hoverBackgroundColor || "#b94e00",
      hoverColor: hoverColor || color,
    },
    outline: {
      backgroundColor: "transparent",
      color: color,
      border: border || `1px solid ${backgroundColor}`,
      hoverBackgroundColor: hoverBackgroundColor || backgroundColor,
      hoverColor: hoverColor || "#ffffff",
    },
    normal: {
      backgroundColor,
      color,
      border: border || "none",
      hoverBackgroundColor: hoverBackgroundColor || "#b94e00",
      hoverColor: hoverColor || color,
    },
  };

  const styles = variantStyles[variant];

  return (
    <button
      onClick={handleClick}
      style={{
        padding,
        backgroundColor: styles.backgroundColor,
        color: styles.color,
        borderRadius,
        fontSize,
        fontWeight,
        border: styles.border,
      }}
      className={`transition duration-200 ease-in-out ${className}`}
    >
      {children}
    </button>
  );
};

export default Button;
